module.exports = __webpack_public_path__ + "static/media/terranova-logo.b9483dbc.svg";